import m from "../../geodata/es2015/namibiaLow";
window.am4geodata_namibiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/namibiaLow.js
// module id = null
// module chunks = 